<template>
  <Modal closable>
    <template v-slot:header>
      <h2 v-if="state.step == 1">Hvad planlægger du?</h2>
      <h2 v-else-if="state.step == 2">Hvad skal din rute kaldes?</h2>
    </template>

    <div v-if="state.step == 1">
      <div id="route-types">
        <div class="route-type" @click="setRoutePreset('student')">
          <img src="@/assets/img/vehicle_truck.svg" />
          <h3>Vogntur</h3>
          <p class="text-secondary text-small">Estimér kørslen af en studentervogn.</p>
        </div>
        <div class="route-type" @click="setRoutePreset('car')">
          <img src="@/assets/img/vehicle_car.svg" />
          <h3>Køretur</h3>
          <p class="text-secondary text-small">Klassisk ruteplanlægning gjort nemt.</p>
        </div>
        <div v-if="false" class="route-type" @click="setRoutePreset('bike')">
          <img src="@/assets/icons/preset-delivery.svg" />
          <h3>Cykeltur</h3>
        </div>
        <div v-if="false" class="route-type" @click="setRoutePreset('foot')">
          <img src="@/assets/icons/preset-walk.svg" />
          <h3>Gåtur</h3>
        </div>
        <!--
        <div class="route-type" @click="create('pubcrawl')">
          <img src="@/assets/icons/preset-pubcrawl.svg" />
          <h3>Pubcrawl</h3>
        </div>
        <div class="route-type" @click="create('')">
          <img src="@/assets/icons/preset-none.svg" />
          <h3>Andet</h3>
        </div>
        -->
      </div>
    </div>
    <div v-if="state.step == 2">
      <input
        class="fill-x"
        v-model="state.name"
        placeholder="Rutenavn f.eks. Pubcrawl, Levering, Roadtrip"
        @focus="$event.target.select()"
        @keypress.enter="create()"
        v-focus
      />
    </div>

    <template v-slot:footer v-if="state.step == 2">
      <AppButton @click="state.step = 1">Tilbage</AppButton>
      <AppButton @click="create()" color="primary">Opret rute!</AppButton>
    </template>
  </Modal>
</template>

<script lang="ts">
import { defineComponent, reactive } from 'vue'
import { store } from '@/store'

import router from '@/router'
import { RouteSettingsModel, RouteSettingsPreset } from '@/api/tripply/models'

export default defineComponent({
  name: 'CreateRoute',
  setup() {
    const state = reactive<{
      step: number;
      name: string;
      preset: string;
    }>({
      step: 1,
      name: '',
      preset: ''
    })
    
    let routeSettings = new RouteSettingsModel()

    function setRoutePreset(preset: RouteSettingsPreset) {     
      routeSettings = new RouteSettingsModel(preset)
      state.name = routeSettings.name
      state.step = 2
    }

    function create() {
      routeSettings.name = state.name
      const routeId = store.route.createRoute(routeSettings)
      store.modal.hideModal('CreateRoute')
      routeId && router.push(`/r/${routeId}`)
    }
    return { create, state, setRoutePreset }
  }
})
</script>

<style lang="scss" scoped>
#route-name {
  margin: 0 0 0.5rem;
}

#route-types {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;

  .route-type {
    background: rgba(255,255,255,0.05);
    padding: 1.5rem .5rem;
    border-radius: 1rem;
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-end;
    border: 1px solid var(--color-divider);
    cursor:pointer;
    &:hover {
      img {
        transform: scale(1.1);
      }
    }
    img {
      transition: transform .3s;
      width: 100%;
      margin-bottom: .5rem;
    }

    h3 {
      margin: 0;
      font-size: 1.25rem;
    }
  }
}
</style>